module.exports = __webpack_public_path__ + "img/mastercard.ced58ce6.svg";